<template>
  <div>
    <breadcrumbs home="Category"/>

    <v-card flat >
      <v-form v-model="valid">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field label="Name" v-model="category.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4">
              <inventory-categories-select v-model="category.parentId" label="Parent" :type="type"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'

export default {
  name: 'InventoryCategoriesEdit',
  mixins: [confirmLeave],
  components: {InventoryCategoriesSelect},
  props: {
    type: {type:String, required:true},
    categoryId: {type:String, required:false}
  },
  data () {
    return {
      category: {name:'',parentId:null,type:this.type},
      dirty: false,
      saving: false,
      loading: false,
      valid: true
    }
  },
  watch: {
    category: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
  async created() {
    if (this.categoryId) {
      this.loading = true;
      const results = await this.$apiCall(`query InventoryCategoriesEdit($categoryId:ID!) {
                                              category(id:$categoryId)  {
                                                id,name,parent{id}
                                              }
                                            }`,
                                          {categoryId:this.categoryId});
      if (!results.error)
        this.category = {...results.data.category, parentId:results.data.category.parent?.id ?? null, parent:undefined};
      this.$nextTick(() => this.dirty = false);
      this.loading = false;
    }
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const results = await this.$apiCall(`mutation InventoryCategoriesEdit($input: CategoryInput!) {
                                             categoryCreate(input:$input) {id}
                                          }`, {input:this.category});
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.categoryId?'Updated':'Created'} category`});
      }
    }
  }
}
</script>